import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { protectSheetWithRandomPassword } from "../ExcelUtils";

async function interestProcessExcel(
    data,
    processDate,
    productName,
    status,
    branchName,
    loginPlaceId
) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("GN Wise Report");

    /* =========================
        1. DEFINE COLUMN STRUCTURE
    ========================== */
    // Define keys and widths first, but we will add the Header row text manually
    sheet.columns = [
        { key: "customerNumber", width: 18 },
        { key: "customerName", width: 50 },
        { key: "accountNumber", width: 20 },
        { key: "minimumBalance", width: 18 },
        { key: "interestAmount", width: 18 }
    ];

    /* =========================
        2. REPORT HEADER (TITLE)
    ========================== */
    const titleRow = sheet.addRow([`INTEREST PROCESS REPORT - ${branchName || 'N/A'}`]);
    sheet.mergeCells(`A${titleRow.number}:E${titleRow.number}`);
    titleRow.font = { bold: true, size: 16 };
    titleRow.alignment = { horizontal: "center", vertical: "middle" };
    titleRow.height = 30;
    titleRow.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFB4C6E7" }
    };

    // Metadata Row
    const infoRow = sheet.addRow([
        `Date : ${processDate}`,
        "",
        `Product : ${productName}`,
        "",
        `Status : ${status}`
    ]);
    sheet.mergeCells(`A${infoRow.number}:B${infoRow.number}`);
    sheet.mergeCells(`C${infoRow.number}:D${infoRow.number}`);
    infoRow.font = { bold: true };

    sheet.addRow([]); // Spacer

    /* =========================
        3. COLUMN HEADERS
    ========================== */
    const headerTitles = ["Customer No", "Customer Name", "Account No", "Minimum Balance", "Interest Amount"];
    const headerRow = sheet.addRow(headerTitles);

    headerRow.font = { bold: true, color: { argb: "FFFFFFFF" } };
    headerRow.eachCell((cell) => {
        cell.alignment = { horizontal: "center" };
        cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FF4472C4" } // Professional Blue
        };
        cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
        };
    });

    /* =========================
        4. DATA & GROUPING
    ========================== */
    const grouped = {};
    data.forEach(row => {
        if (!grouped[row.gnName]) grouped[row.gnName] = [];
        grouped[row.gnName].push(row);
    });

    let grandMinTotal = 0;
    let grandInterestTotal = 0;

    Object.entries(grouped).forEach(([gnName, rows]) => {
        const gnRow = sheet.addRow([`Wasam : ${gnName}`]);
        sheet.mergeCells(`A${gnRow.number}:E${gnRow.number}`);
        gnRow.font = { bold: true };
        gnRow.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFEFEFEF" } };

        let gnMinTotal = 0;
        let gnInterestTotal = 0;

        rows.forEach(r => {
            const row = sheet.addRow({
                customerNumber: r.customerNumber,
                customerName: r.customerName,
                accountNumber: r.accountNumber,
                minimumBalance: r.minimumBalance,
                interestAmount: r.interestAmount
            });
            row.getCell("minimumBalance").numFmt = "#,##0.00";
            row.getCell("interestAmount").numFmt = "#,##0.00";
            gnMinTotal += Number(r.minimumBalance || 0);
            gnInterestTotal += Number(r.interestAmount || 0);
        });

        const totalRow = sheet.addRow({
            customerName: "GN TOTAL",
            minimumBalance: gnMinTotal,
            interestAmount: gnInterestTotal
        });
        totalRow.font = { bold: true };
        totalRow.getCell("minimumBalance").numFmt = "#,##0.00";
        totalRow.getCell("interestAmount").numFmt = "#,##0.00";

        grandMinTotal += gnMinTotal;
        grandInterestTotal += gnInterestTotal;
        sheet.addRow([]);
    });

    /* =========================
        5. GRAND TOTAL
    ========================== */
    const grandRow = sheet.addRow({
        customerName: "GRAND TOTAL",
        minimumBalance: grandMinTotal,
        interestAmount: grandInterestTotal
    });
    grandRow.font = { bold: true, size: 12 };
    grandRow.eachCell(cell => {
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFC6E0B4" } };
    });

    if (loginPlaceId === "1") {
        const password = protectSheetWithRandomPassword(sheet, 12);
    }

    sheet.views = [{ state: "frozen", ySplit: 4 }];
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), `Interest_Report_${branchName}_${processDate}.xlsx`);
}

export { interestProcessExcel };